import type { QueryOptions } from '@tanstack/react-query';

import { http } from '@/api/instance';
import { getQueryParameters } from '@/api/query';

export const studentAPI = {
  list: ({ ...params }: Record<string, string | number>) =>
    http.get<ListResultsPageSize<Student>>('/api/info/students', { params }).then(({ data }) => data),

  quit: (data: StudentQuitPayload) => http.patch('/api/edit/contracts/class/quit', { data }),
  reserve: (data: StudentReservePayload) => http.patch('/api/edit/contracts/class/reserve', { data }),
  transfer: (data: StudentTransferPayload) => http.patch('/api/edit/contracts/class/transfer', { data }),
  rejoin: (data: StudentRejoinPayload) => http.patch('/api/edit/contracts/class/rejoin', { data }),
};

export const studentQuery = {
  list: (params: QueryParams<Partial<SearchFormData>>) =>
    ({
      queryKey: ['GetStudentList', params] as const,
      queryFn: () => studentAPI.list(getQueryParameters(params)),
    }) as const satisfies QueryOptions,
};
